import { FAQCategory } from '../models/faq.interface';

export const faqCategories: FAQCategory[] = [
  {
    id: 'general',
    title: 'Información General',
    questions: [
      {
        id: 'que-es-unipay',
        question: '¿Qué es Unipay?',
        answer: 'Unipay es una Tarjeta de Crédito 100% digital. No necesitas un plástico para usarla. Puedes pagar solo con tu huella: simple, cómodo y seguro.',
        isOpen: false
      },
      {
        id: 'como-funciona',
        question: '¿Cómo funciona Unipay?',
        answer: 'Unipay funciona como una tarjeta de crédito que te permite realizar compras en comercios asociados utilizando tu huella digital. No necesitas llevar una tarjeta física, solo debes registrar tu huella al momento de solicitar tu Unipay y utilizarla para realizar tus compras.',
        isOpen: false
      },
      {
        id: 'donde-usar',
        question: '¿Dónde puedo usar mi Unipay?',
        answer: 'Puedes usar tu Unipay en todos los supermercados Unimarc, Mayorista 10 y Alvi del país, además de otros comercios asociados como farmacias, tiendas de retail y estaciones de servicio.',
        isOpen: false
      },
      {
        id: 'beneficios',
        question: '¿Qué beneficios tiene Unipay?',
        answer: 'Con Unipay obtienes descuentos exclusivos en supermercados Unimarc, Mayorista 10 y Alvi, puedes solicitar avances en efectivo de hasta $200.000 y super avances de hasta $4.000.000 (sujeto a evaluación crediticia), además de poder realizar todas tus compras utilizando solo tu huella digital.',
        isOpen: false
      }
    ]
  },
  {
    id: 'solicitud',
    title: 'Solicitud y Requisitos',
    questions: [
      {
        id: 'requisitos',
        question: '¿Cuáles son los requisitos para solicitar Unipay?',
        answer: [
          'Tener entre 30 y 74 años',
          'Cédula de identidad vigente y sin bloqueo',
          'Ingresos acreditables, recurrentes y estables',
          'Teléfono celular activo',
          'Acreditación de domicilio'
        ],
        isOpen: false
      },
      {
        id: 'como-solicitar',
        question: '¿Cómo puedo solicitar mi Unipay?',
        answer: 'Puedes solicitar tu Unipay a través de nuestra página web completando el formulario de solicitud, llamando al 600 390 9001 o acercándote a cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi.',
        isOpen: false
      },
      {
        id: 'tiempo-aprobacion',
        question: '¿Cuánto tiempo tarda la aprobación de mi Unipay?',
        answer: 'El proceso de evaluación y aprobación de tu Unipay puede tomar entre 24 a 48 horas hábiles. Una vez aprobada, recibirás un mensaje de texto con la confirmación y las instrucciones para activar tu cuenta.',
        isOpen: false
      },
      {
        id: 'documentos',
        question: '¿Qué documentos necesito para solicitar Unipay?',
        answer: 'Necesitas presentar tu cédula de identidad vigente, comprobante de domicilio (boleta de servicios básicos no mayor a 60 días) y acreditación de ingresos (últimas 3 liquidaciones de sueldo, declaración de impuestos o boletas de honorarios).',
        isOpen: false
      }
    ]
  },
  {
    id: 'uso',
    title: 'Uso y Funcionamiento',
    questions: [
      {
        id: 'como-pagar',
        question: '¿Cómo realizo pagos con mi Unipay?',
        answer: 'Para realizar pagos con tu Unipay solo debes indicar en caja que pagarás con Unipay y colocar tu huella digital en el lector biométrico. No necesitas llevar una tarjeta física.',
        isOpen: false
      },
      {
        id: 'cupo',
        question: '¿Cómo sé cuál es mi cupo disponible?',
        answer: 'Puedes consultar tu cupo disponible a través de WhatsApp al +569 58123297, llamando al 600 390 9001 o en cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi.',
        isOpen: false
      },
      {
        id: 'avances',
        question: '¿Cómo solicito un avance en efectivo?',
        answer: 'Puedes solicitar un avance en efectivo a través de WhatsApp al +569 58123297, llamando al 600 390 9001 o en cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi. El monto máximo para avances es de $200.000, sujeto a disponibilidad de cupo.',
        isOpen: false
      },
      {
        id: 'super-avances',
        question: '¿Cómo solicito un Super Avance?',
        answer: 'Puedes solicitar un Super Avance a través de WhatsApp al +569 58123297, llamando al 600 390 9001 o en cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi. Los montos van desde $300.000 hasta $4.000.000, sujeto a evaluación crediticia.',
        isOpen: false
      }
    ]
  },
  {
    id: 'pagos',
    title: 'Pagos y Estado de Cuenta',
    questions: [
      {
        id: 'donde-pagar',
        question: '¿Dónde puedo pagar mi estado de cuenta?',
        answer: [
          'En todas las cajas de Supermercados Unimarc, Mayorista 10 y Alvi sólo dictando tu Rut. Pagos en línea, sólo en efectivo.',
          'En www.unipay.cl, podrás elegir pagar a través de EtPay, directamente desde tu banco y a través de Unired.cl o WebPay Plus.',
          'También puedes ingresar directamente en www.unired.cl ingresando con tu número de Rut, donde pagarás con tarjetas de débito y crédito.',
          'Pagos en todas las cajas de Sucursales Servipag sólo dictando tu Rut y sólo en efectivo. Estos pagos se registran en tu cuenta Unipay con la fecha en que se realiza la operación y los cupos serán liberados en la cuenta a las 48 hrs. de realizado el pago. '
        ],
        isOpen: false
      },
      {
        id: 'fecha-pago',
        question: '¿Cuál es la fecha de pago de mi estado de cuenta?',
        answer: 'La fecha de pago de tu estado de cuenta se encuentra detallada en tu estado de cuenta mensual. También puedes consultarla a través de WhatsApp al +569 58123297 o llamando al 600 390 9001.',
        isOpen: false
      },
      {
        id: 'monto-minimo',
        question: '¿Cuál es el monto mínimo que debo pagar?',
        answer: 'El monto mínimo a pagar se encuentra detallado en tu estado de cuenta mensual. También puedes consultarlo a través de WhatsApp al +569 58123297 o llamando al 600 390 9001.',
        isOpen: false
      },
      {
        id: 'estado-cuenta',
        question: '¿Cómo puedo obtener mi estado de cuenta?',
        answer: 'Tu estado de cuenta es enviado mensualmente a tu correo electrónico registrado. También puedes solicitarlo a través de WhatsApp al +569 58123297, llamando al 600 390 9001 o en cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi.',
        isOpen: false
      }
    ]
  },
  {
    id: 'problemas',
    title: 'Problemas y Soporte',
    questions: [
      {
        id: 'bloqueo',
        question: '¿Qué hago si necesito bloquear mi Unipay?',
        answer: 'Si necesitas bloquear tu Unipay, debes llamar inmediatamente al 600 390 9001 o acercarte a cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi.',
        isOpen: false
      },
      {
        id: 'huella',
        question: '¿Qué hago si mi huella no es reconocida?',
        answer: 'Si tu huella no es reconocida, debes acercarte a cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi para actualizar tu registro biométrico. También puedes llamar al 600 390 9001 para recibir asistencia.',
        isOpen: false
      },
      {
        id: 'robo',
        question: '¿Qué hago en caso de robo o pérdida de mi documento de identidad?',
        answer: 'En caso de robo o pérdida de tu documento de identidad, debes bloquear inmediatamente tu Unipay llamando al 600 390 9001 y realizar la denuncia correspondiente en Carabineros o PDI.',
        isOpen: false
      },
      {
        id: 'contacto',
        question: '¿Cómo puedo contactar a servicio al cliente?',
        answer: 'Puedes contactar a nuestro servicio al cliente a través de WhatsApp al +569 58123297, llamando al 600 390 9001 o acercándote a cualquier módulo Unipay en supermercados Unimarc, Mayorista 10 o Alvi.',
        isOpen: false
      }
    ]
  }
];